module.exports = __webpack_public_path__ + "img/icon_map_62_off_010.d0be642c.png";